import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import store from './store/index';
import '@/css/reset.scss';
import "./css/popular_css.scss";
import {priceRebuild, timeRebuild} from "./utils/common";

Vue.config.productionTip = false;

Vue.filter('date', timeRebuild);
Vue.filter('price', priceRebuild);


router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})
Vue.filter('formateChange', function (value) {
  if (!value) return '';
  const date = new Date(Number(value));
  let y = date.getFullYear();
  let m = String(date.getMonth() + 1).length === 1 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  let d = String(date.getDate()).padStart(2, '0');
  var h = String(date.getHours()).padStart(2, '0');
  var o = String(date.getMinutes()).padStart(2, '0');
  var s = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${o}:${s}`;
});
Vue.filter('formateTitle', function (value) {
  if (!value) return '';
  const date = new Date(Number(value));
  let y = date.getFullYear();
  let m = String(date.getMonth() + 1).length === 1 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  let d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
});
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
